import { useEffect, useState } from "react";
import { publicApi } from "@/lib/publicApi";
import { PageHero } from "@/components/public/Primitives";
import BlogCard from "@/components/public/BlogCard";
import CTASection from "@/components/public/CTASection";
import SEO from "@/components/public/SEO";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => { publicApi.get("/blog").then((r) => setPosts(r.data || [])).catch(() => {}); }, []);
    return (
        <div data-testid="blog-page">
            <SEO
                title="Blog — Practical Advice for UK Small Businesses"
                description="Straight-talking articles on websites, mobile apps, WhatsApp ordering, SEO basics and growing your UK small business online — written by the Omega IT Ltd team."
            />
            <PageHero eyebrow="Blog" title="Practical advice for UK small businesses." subtitle="Straight-talking articles on websites, apps, WhatsApp ordering, SEO and growing your business online." />
            <section className="px-5 sm:px-8 lg:px-12 py-20">
                <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {posts.map((p) => (<BlogCard key={p.id} post={p} />))}
                </div>
            </section>
            <CTASection />
        </div>
    );
}
